import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "@/context/AuthContext";
import AuthShell from "@/components/AuthShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const user = await login(email, password);
      const dest = ["admin", "super_admin"].includes(user.role) ? "/ops"
        : user.role === "provider" ? "/provider/dashboard" : "/app";
      navigate(dest);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell testid="login-page" title="Welcome back" subtitle="Sign in to continue your family's path.">
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        {error && (
          <div className="text-sm text-kid-coral bg-red-50 border border-red-100 rounded-xl px-4 py-3" data-testid="login-error">
            {error}
          </div>
        )}
        <div className="space-y-1.5">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                 required data-testid="login-email-input" placeholder="you@example.com" className="h-12 rounded-xl" />
        </div>
        <div className="space-y-1.5">
          <div className="flex justify-between items-center">
            <Label htmlFor="password">Password</Label>
            <Link to="/forgot-password" className="text-sm text-kid-teal font-poppins" data-testid="forgot-password-link">Forgot password?</Link>
          </div>
          <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                 required data-testid="login-password-input" placeholder="••••••••" className="h-12 rounded-xl" />
        </div>
        <button type="submit" disabled={busy} className="kid-btn kid-btn-primary w-full h-12 text-base disabled:opacity-60" data-testid="login-submit-button">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <p className="text-center text-sm text-kid-muted mt-6">
        New to KidPath?{" "}
        <Link to="/register" className="text-kid-teal font-semibold" data-testid="go-register-link">Start free</Link>
      </p>
    </AuthShell>
  );
}
